var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009393",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47 8 27.27 15.63 15h24.74L48 27.27 28 47Zm2-18v-2.44c3.6.18 6.96.88 8 1.79-1.21 1.06-5.54 1.83-10 1.83s-8.79-.77-10-1.83c1.03-.91 4.4-1.6 8-1.8V29h4Zm-12-.66v1.47c1.03.91 4.39 1.6 8 1.8V37h4v-5.4c3.6-.18 6.97-.88 8-1.79V26.88c-1.03-.91-4.4-1.61-8-1.8V23h6v-3H20v3h6v2.08c-3.61.19-6.97.89-8 1.8v1.46Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtLogo);
export default __webpack_public_path__ + "static/media/usdt-logo.1ab449b81782797ef67650fba8e3ed59.svg";
export { ForwardRef as ReactComponent };